module.exports = __webpack_public_path__ + "static/img/hot.a0d5aed5.svg";